/** Finance backend checkers (async validators) unique keys */
export enum FinanceCheckersEnum {
  /** Check whether planning scenario(s) with received ID(s) exist(s) and not deleted */
  PLANNING_SCENARIO_ASSERT_EXISTS_BY_ID = 'finance/planning-scenario-assert-exists-by-id',
  /** Check whether planning scenario(s) with ID(s) extracted from received DTO(s) exist(s) and not deleted */
  PLANNING_SCENARIO_ASSERT_EXISTS_BY_DTO = 'finance/planning-scenario-assert-exists-by-dto',
}
